import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMailchimpSyncStatusQuery = createQueryHook(
  CreatorIntegrationsApiClient.getMailchimpSyncStatus,
  {
    queryKey: ['mailchimpSyncStatus'],
  },
)
